export const CHANGE_SEARCH = 'FILTERS/CHANGE_SEARCH';
export const CHANGE_STATUS = 'FILTERS/CHANGE_STATUS';